import { useMediaQuery } from "@mui/material";
import { useCallback, useState } from "react";
import { useLocation } from "react-router-dom";

export const useAssessment = () => {
  const isLargeScreen = useMediaQuery("(min-width:1000px)");
  const location = useLocation();
  // get the last part of the location pathname
  const path = location.pathname.split("/").pop();

  const isPrinciplesGraph = path === "tl-principles-graph";

  const [open, setOpen] = useState(false);
  const [editMode, setEditMode] = useState(false); // Track if we are in edit mode
  const [currentAssessment, setCurrentAssessment] = useState(null); // Store the assessment being edited

  const handleOpen = useCallback(() => {
    setEditMode(false);
    setCurrentAssessment(null);
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  return {
    open,
    editMode,
    currentAssessment,
    handleOpen,
    handleClose,
    setOpen,
    isLargeScreen,
    isPrinciplesGraph,
  };
};
